import jwtDecode from "jwt-decode";

export class JwtToken {

    constructor(rawJson) {
        this.rawJson = rawJson;
    }

    static fromLocalStorage() {
        return new JwtToken(localStorage.getItem('access_token'));
    }

    userId() {
        const userId = this.getProperty('user_id');

        return parseInt(userId);
    }

    name() {
        return this.getProperty('name');
    }

    email() {
        return this.getProperty('email');
    }

    organizationId() {
        const orgId = this.getProperty('orgid');

        return parseInt(orgId);
    }

    isSystemAdmin() {
        const systemAdmin = this.getProperty('system_admin');

        return systemAdmin === 'true';
    }

    associations() {
        return JSON.parse(this.getProperty('roles'))
    }

    homeUrl() {
        return this.getProperty('home_url');
    }

    isProfileSwitcher() {

        const profileSwitcher = this.getProperty('ProfilSwitcher');

        return profileSwitcher && profileSwitcher.toLowerCase() === "true";
    }

    decoded() {
        return this.rawJson ? jwtDecode(this.rawJson) : null;
    }

    getProperty(name) {

        const token = this.decoded();

        if (token) {
            return token[name];
        }

        return null;
    }
}